<template>
    <div class="users-table">
        <div class="user-header d-flex">
            <span>User Rank</span>
            <span>Earnings</span>
            <span>Country</span>
        </div>

        <div class="users-list hide-scrollbar">
            <div v-for="(user, index) in users" :key="user.id" class="user-info mt-4" :class="getUserPosition(index)">
                <div class="d-flex align-center">
                    <img v-if="index < 3" :src="`/assets/${getUserPosition(index)}.svg`"
                        :width="index < 2 ? '20px' : '22px'" height="20px" alt="">
                    <div v-else class="text-14">
                        {{ index + 1 }}
                    </div>
                    <img :src="user.picture" width="30px" height="30px" class="ml-5 user-picture" alt=""
                        style="border-radius: 100px">
                    <span class="ml-2 user-name">{{ user.name }}</span>
                </div>

                <div class="coins-amount">
                    <coin-chip>
                        <template #amount>
                            <span class="ml-1" style="font-weight: 600;">
                                {{ Math.floor(user.coins_earned) }}
                            </span>
                        </template>
                    </coin-chip>
                </div>

                <country-flag :country="user.country.toLowerCase()" />
            </div>
        </div>
    </div>
</template>

<script>
import CoinChip from "@/components/Common/CoinChip.vue";
import CountryFlag from "vue-country-flag-next";

export default {
    name: "UsersList",
    props: {
        users: {
            type: Array,
            required: true
        }
    },
    components: {
        CoinChip,
        CountryFlag
    },
    data() {
        return {}
    },
    methods: {
        getUserPosition(index) {
            let position = '';
            switch (index) {
                case 0:
                    position = 'gold'
                break;
                case 1:
                    position = 'silver'
                break;
                case 2:
                    position = 'bronze'
                break
            }

            return position;
        }
    }
}
</script>

<style scoped lang="scss">
.users-table {
    margin-top: 30px;

    .user-header {
        color: #8E8E8E;
        font-size: 16px;
        font-weight: 500;
        padding: 8px 12px 0 12px;
        background: transparent;

        :nth-child(1),
        :nth-child(2) {
            width: 47%;
        }
    }

    .users-list {
        overflow-y: auto;

        .user-info {
            display: flex;
            border-radius: 12px;
            align-items: center;
            padding: 8px 12px 8px 12px;

            &.gold {
                border-left: 2px solid #E5B52B;
                background: linear-gradient(270deg, rgba(33, 35, 44, 0) 0%, rgba(229, 181, 43, 0.15) 100%),
                    linear-gradient(0deg, #21242C, #21242C);
            }

            &.silver {
                border-left: 2px solid #C2C7CD;
                background: linear-gradient(270deg, rgba(33, 35, 44, 0) 0%, rgba(194, 199, 205, 0.15) 100%),
                    linear-gradient(0deg, #21242C, #21242C);
            }

            &.bronze {
                background: linear-gradient(270deg, rgba(33, 35, 44, 0) 0%, rgba(109, 54, 18, 0.15) 100%),
                    linear-gradient(0deg, #21242C, #21242C);
            }

            .d-flex,
            .coins-amount {
                width: 47%;
            }

            .text-14 {
                width: 22px;
                text-align: center;
            }

            background: linear-gradient(0deg, #21242C, #21242C);

            .flag {
                margin-top: -8px;
            }
        }
    }

    @media only screen and (max-width: vars.get-map-value(vars.$breakpoints, tab)) {
        .users-list {

            .d-flex,
            .coins-amount {
                width: 46% !important;
            }
        }
    }

    @media only screen and (max-width: vars.get-map-value(vars.$breakpoints, mobile)) {
        .header {
            div:first-child {
                width: 54% !important;
            }

            :nth-child(2) {
                width: 25% !important;
            }
        }

        .users-list {
            .coins-amount {
                width: 30% !important;
            }

            .d-flex {
                width: 54% !important;

                .user-picture {
                    border-radius: 100px;
                    margin-left: 6px !important;
                }

                //width: 75% !important;
                .user-name {
                    font-size: 14px;
                    font-weight: 500;
                    opacity: 0.8;
                    width: 100px;
                    overflow: hidden;
                    white-space: nowrap;
                    text-overflow: ellipsis;
                }
            }
        }
    }
}
</style>
